import { useQuery } from '@tanstack/react-query';
import { WalletSummary } from '../../interface/walet';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

const getWalletSummary = async () => {
  const { data } = await api.get<WalletSummaryResponse>(
    apiConfig.routes.wallet.summary
  );
  return data;
};

export const useGetWalletSummary = () =>
  useQuery({
    queryKey: ['wallet', 'summary'],
    queryFn: getWalletSummary,
  });

type WalletSummaryResponse = WalletSummary;
